var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _vm.formName,
    _vm._g(
      _vm._b(
        {
          key: _vm.formName,
          tag: "div",
          attrs: { submitting: _vm.submitting },
          on: { input: _vm.onInput }
        },
        "div",
        {
          ..._vm.$attrs,
          isPublisher: _vm.isPublisher,
          isPubManager: _vm.isPubManager,
          availableCountries: _vm.availableCountries
        },
        false
      ),
      _vm.$listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }